

































































































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getInfo, VideoData, emptyData } from '@/api/videoDevice/index'
//import ViewLink from '@/components/viewLink.vue'
import VideoPointsView from './point/list.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: {
    ViewDialog, VideoPointsView
  }
})
export default class UnitDeviceView extends Vue {
  public collapseNames: string[] = ['base', 'points']
  public showDialog: boolean = false
  public loading: boolean = false

  public form: VideoData = Object.assign({}, emptyData)
  public $refs!: {}
  public created() { }
  public mounted() {
    window.eventBus.$on('viewVideoDevice', (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewVideoDevice')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    getInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
}
